// import qs from 'qs';
import axios from 'axios';
import config from '../common/config';

const CLIENT_ID = 'fbb60590d660043';

export default {
  authenticate(email, password=null, googleIdToken=null) {
    const formData = new FormData();
    formData.append('email', email);
    formData.append('password', password);
    formData.append('googleIdToken', googleIdToken);
    return axios.post(`${config.config.ROOT_URL}/app_login`,formData);
  },
  registerNewUser(email, password, userName) {
    const formData = new FormData();
    formData.append('email', email);
    formData.append('password', password);
    formData.append('userName', userName);
    return axios.post(`${config.config.ROOT_URL}/register_new_user_api`,formData);
  }
    // window.location = `${config.config.ROOT_URL}/app_login?${qs.stringify(
    //   querystring
    //   )}`;
    // }
  // login(username, password) {
  //   const querystring = {
  //     username: username,
  //     passsword: password
  //   };
  //   window.location = `${config.config.ROOT_URL}/app_login?${qs.stringify(
  //     querystring
  //   )}`;
  // }
};
